import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const appointmentService = {
  getAllAppointments: async () => {
    try {
      const response = await axios.get(`${API_URL}/appointments/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      return [];
    }
  },
  
  getAppointmentsByUser: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/appointments/user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user appointments:', error);
      return [];
    }
  },
  
  getAppointmentsByDoctor: async (doctorId) => {
    try {
      const response = await axios.get(`${API_URL}/appointments/doctor/${doctorId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching doctor appointments:', error);
      return [];
    }
  },
  
  createAppointment: async (appointmentData) => {
    try {
      console.log('Service sending appointment data:', appointmentData);
      const response = await axios.post(`${API_URL}/appointments`, {
        title: appointmentData.title,
        description: appointmentData.description,
        doctorId: appointmentData.doctorId,
        patientId: appointmentData.patientId,
        startTime: appointmentData.startTime,
        endTime: appointmentData.endTime,
        // Explicitly include the meeting link fields
        meetingLink: appointmentData.meetingLink,
        meetingPassword: appointmentData.meetingPassword
      });
      
      console.log('Service received response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating appointment:', error);
      throw error;
    }
  },
  
  updateAppointment: async (id, appointmentData) => {
    try {
      const response = await axios.put(`${API_URL}/appointments/${id}`, appointmentData);
      return response.data;
    } catch (error) {
      console.error('Error updating appointment:', error);
      throw error;
    }
  },
  
  deleteAppointment: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/appointments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting appointment:', error);
      throw error;
    }
  },
  
  getAvailableSlots: async (doctorId, date) => {
    try {
      console.log(`Requesting available slots for doctor ${doctorId} on ${date}`);
      const response = await axios.get(`${API_URL}/appointments/available-slots`, {
        params: { doctorId, date }
      });
      
      console.log(`Received ${response.data.length} available slots from API`);
      return response.data;
    } catch (error) {
      console.error('Error fetching available slots:', error);
      console.log('Falling back to default slots');
      // Return default slots as a fallback
      return generateDefaultTimeSlots(new Date(date));
    }
  },
  
   // Fix the getAvailableDoctorsForDate function
getAvailableDoctorsForDate: async (date) => {
    try {
      console.log(`Requesting all available doctors for date: ${date}`);
      const response = await axios.get(`${API_URL}/appointments/available`, {
        params: { date }
      });
      console.log('Available doctors response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching available doctors:', error);
      return [];
    }
  },
  
  // Fix the getDoctorSchedule function
  getDoctorSchedule: async (doctorId) => {
    try {
      console.log(`Fetching schedule for doctor: ${doctorId}`);
      const response = await axios.get(`${API_URL}/appointments/${doctorId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching doctor schedule:', error);
      return null;
    }
  },
  
  // Fix the updateDoctorSchedule function
  updateDoctorSchedule: async (doctorId, scheduleData) => {
    try {
      console.log(`Updating schedule for doctor: ${doctorId}`);
      const response = await axios.post(`${API_URL}/appointments/${doctorId}`, scheduleData);
      return response.data;
    } catch (error) {
      console.error('Error updating doctor schedule:', error);
      throw error;
    }
  }
};

// Helper function to generate default time slots
function generateDefaultTimeSlots(date) {
  const slots = [];
  const baseDate = new Date(date);
  baseDate.setHours(9, 0, 0, 0); // Start at 9 AM
  
  for (let i = 0; i < 16; i++) { // 8 hours with 30 min slots
    const startTime = new Date(baseDate);
    startTime.setMinutes(startTime.getMinutes() + i * 30);
    
    const endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + 30);
    
    // Only include future slots if today
    const now = new Date();
    if (startTime > now || baseDate.toDateString() !== now.toDateString()) {
      slots.push({
        startTime: startTime,
        endTime: endTime
      });
    }
  }
  
  return slots;
}